import React from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  Button,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

const Hero = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{

        position: "relative",
        overflow: "hidden",
        pt: { xs: 8, md: 12 },
        pb: { xs: 4, md: 2 },

      }}
    >

      <Box
        sx={{
          position: "absolute",
          width: 500,
          height: 500,
          borderRadius: "50%",
          top: -150,
          right: -150,
          filter: "blur(120px)",
          zIndex: 0,
        }}
      />

      <Box
        sx={{
          position: "absolute",
          width: 600,
          height: 600,
          top: -200,
          left: -200,
          animation: "float 8s ease-in-out infinite",
          zIndex: 0,
          "@keyframes float": {
            "0%": { transform: "translateY(0px)" },
            "50%": { transform: "translateY(40px)" },
            "100%": { transform: "translateY(0px)" },
          },
        }}
      />

      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
        <Grid container spacing={6} alignItems="center">

          <Grid item xs={12} md={6}>
            <Typography
              sx={{
                fontSize: { xs: "20px", sm: "28px", md: "40px" },
                fontWeight: 600,
                lineHeight: 1.2,
                color: theme.palette.text.primary,
                mb: 3,
                mt: { xs: "18px", sm: "28px" },
                // background: { xs: "green", sm: "red", md: "blue" }
              }}
            >
              A{" "}
              <Box
                component="span"
                sx={{
                  background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.text.primary})`,
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                community-first wealth platform
              </Box>{" "}
              exclusively serving{" "}
              <Box
                component="span"
                sx={{
                  background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.text.primary})`,
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                government and public sector workforce
              </Box>
              .
            </Typography>

            <Typography
              sx={{
                fontSize: { xs: "12px", sm: "14px", md: "16px" },

                color: theme.palette.text.secondary,
                mb: 4,
              }}
            >
              Smarter investments. Stronger insurance. Simpler banking.
              Designed with trust, clarity, and respect.
            </Typography>

            <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
              <Button
                variant="contained"
                sx={{
                  px: 2,
                  // py: 1.5,
                  borderRadius: "12px",
                  textTransform: "none",
                  fontWeight: 600,
                  backgroundColor: "#0080a7",

                }}
              >
                ArthGyan Journey
              </Button>


            </Box>
          </Grid>

          <Grid item xs={12} md={6} textAlign="center">
            <Box
              component="img"
              src="https://ik.imagekit.io/arthgyan/Arthgyan_Web/%20Image%20png"
              alt="Hero"
              sx={{
                width: "100%",
                maxWidth: 820,
                // boxShadow: "0px 30px 60px rgba(0,0,0,0.15)",
                boxShadow: `0px 30px 60px ${theme.palette.primary.main}20`,
              }}
            />
            <Typography style={{ color: theme.palette.primary.main, fontWeight: 500, fontSize: "13px" }}>WE SERVE THOSE WHO SERVE THE NATION.</Typography>
          </Grid>

        </Grid>
      </Container>
    </Box>
  );
};

export default Hero;
